import script from "./ContactView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactView.vue?vue&type=script&setup=true&lang=js"

import "./ContactView.vue?vue&type=style&index=0&id=56d9054e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d9054e"]])

export default __exports__